export default __webpack_public_path__ + "static/media/handicap.797273ad.png";